const mask = () => {
const formatNumber = (newValue) => {
  const onlyDigits = newValue.replace(/\D/g, '');

  if (onlyDigits.length <= 10) {
    return ["(", /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
  } else {
    return ["(", /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/];
  }
};


  const inscricaoEstadualMask = [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/];

  const inscricaoMunicipalMask = (rawValue = "") => rawValue.split("").map(() => /\d/);

  const cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
  const dateMask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];

  const cpfCnpj = (newValue = "") => {
    const rawValue = String(newValue);
    const alnumOnly = rawValue.replace(/[^A-Za-z0-9]/g, "");
    const hasAlpha = /[A-Za-z]/.test(alnumOnly);

    if (!hasAlpha && alnumOnly.length <= 11) {
      // CPF
      return [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];
    } else {
      // CNPJ
      return [/[A-Za-z0-9]/, /[A-Za-z0-9]/, ".", /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, ".", /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, "/", /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, "-", /\d/, /\d/];
    }
  };

  const moneyFormat = ["R", "$", " ", /[1-9]/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ",", /\d/, /\d/];

  const formatNumerFix = (phoneNumber) => {
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");

    if (cleaned.length < 1) return cleaned;

    let ddd = "";
    let rest = "";

    if (cleaned.length > 10) {
      ddd = cleaned.slice(0, 2);
      rest = cleaned.slice(2);
    } else {
      ddd = cleaned.slice(0, 2);
      rest = cleaned.slice(2);
    }

    const formattedNumber = `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;

    return formattedNumber;
  };
  function dateRoteirizacao(date) {
    const [day, month] = date.split("/");
    const months = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
    return `${months[parseInt(month) - 1]}/${day}`;
  }
  function formatDate(value) {
    if (!value) return "";
    if (value.includes("/")) return value;

    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return value;

    const [, year, month, day] = match;

    return `${day}/${month}/${year}`;
  }

  function formatCepValue(value) {
    const digits = String(value || "").replace(/\D/g, "");
    if (!digits) return "";
    return digits.replace(/(\d{0,5})(\d{0,3}).*/, (m, a, b) => (a || "") + (b ? "-" + b : ""));
  }

  function formatCpfCnpjValue(value) {
    const rawValue = String(value || "");
    const alnumOnly = rawValue.replace(/[^A-Za-z0-9]/g, "");
    if (!alnumOnly) return "";

    const hasAlpha = /[A-Za-z]/.test(alnumOnly);
    if (!hasAlpha && alnumOnly.length <= 11) {
      return alnumOnly.replace(
        /(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/,
        (m, a, b, c, d) =>
          [a, b, c].filter(Boolean).join(".") + (d ? "-" + d : "")
      );
    }

    const base = alnumOnly.toUpperCase();
    const raiz = base.slice(0, 2);
    const parte1 = base.slice(2, 5);
    const parte2 = base.slice(5, 8);
    const ordem = base.slice(8, 12);
    const dv = base.slice(12, 14);

    return [raiz, parte1, parte2].filter(Boolean).join(".") +
      (ordem ? "/" + ordem : "") +
      (dv ? "-" + dv : "");
  }

  return {
    formatNumber,
    inscricaoEstadualMask,
    inscricaoMunicipalMask,
    cepMask,
    cpfCnpj,
    moneyFormat,
    dateMask,
    formatNumerFix,
    dateRoteirizacao,
    formatDate,
    formatCpfCnpjValue,
    formatCepValue,
  };
};

export default mask;
